import './App.css';
import Main from './Main';
import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import PwaInstallGuide from './components/PwaInstallGuide';

function App() {
  // Notification.requestPermission().then((permission) => {
  //   if (permission === "granted") {
  //     console.log("Notifications enabled");
  //   }
  // });


  const isPWA =
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true;

  if (isPWA) {
    const meta = document.createElement("meta");
    meta.name = "viewport";
    meta.content =
      "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover";
    document.head.appendChild(meta);
  }
  return (
    <React.StrictMode>
    <BrowserRouter>
      <Main />
      <PwaInstallGuide />
    </BrowserRouter>
  </React.StrictMode>
  );
}

export default App;
